import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StructCapCRMItem } from '../../models/crm/struct-cap/StructCapCRMItem.model';
import { StructCapCRMDealLabels, StructCapDealType } from '../../enums/struct-cap-crm-deal-type.enum';
import { StructCapCrmDealSourceTypeLabels } from '../../enums/struct-cap-crm-deal-source-type.enum';
import { CompanyStageLabels } from '../../enums/company-stage.enum';
import { HealthcareSubSectorLabels } from '../../enums/healthcare-sub-sector.enum';
import { EventsHubService } from '../../../core/events-hub.service';
import { ArchiveModalComponent } from '../../../modules/crm/crm-item/archive-modal/archive-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CrmItemType } from '../../enums/crm-item-type.enum';
import { STRUCT_CAP_URL_ROOT } from '../../../modules/crm/struct-cap-crm/struct-cap-crm-parent/struct-cap-crm-parent.component';
import { StructCapCrmStatusService } from '../../../core/data-services/struct-cap-crm-status.service';
import { StructCapCrmStatusReasonLabels } from '../../enums/struct-cap-crm-status-reason';
import { STRUCT_CAP_BLOCKING_STATUSES } from '../../enums/struct-cap-crm-status';
import { RmsColors } from '../../constants/rms-colors';

@Component({
    selector: 'rms-struct-cap-crm-item-details',
    templateUrl: './struct-cap-crm-item-details.component.html',
    styleUrls: ['./struct-cap-crm-item-details.component.scss'],
    standalone: false
})
export class StructCapCrmItemDetailsComponent implements OnInit {

  @Input() crmItem: StructCapCRMItem;
  @Input() crmView = true;

  @Output() saveCrmItemEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() archiveCrmItemEvent: EventEmitter<any> = new EventEmitter<any>();

  public isOpen = false;

  public readonly StructCapDealSourceTypeLabels = StructCapCrmDealSourceTypeLabels;
  public readonly CompanyStageLabels = CompanyStageLabels;
  public readonly HealthcareSubsectorLabels = HealthcareSubSectorLabels;
  public readonly CRM_ITEM_ROUTE = `/sonar/${STRUCT_CAP_URL_ROOT}/item/`;
  public readonly StructCapStatusReasonLabels = StructCapCrmStatusReasonLabels;
  public readonly BLOCKING_STATUSES = STRUCT_CAP_BLOCKING_STATUSES;

  public readonly RMS_PRIMARY_COLOR = RmsColors.RMS_PRIMARY_COLOR;

  constructor(
    private eventsHubService: EventsHubService,
    private modalService: NgbModal,
    public crmStatusService: StructCapCrmStatusService
  ) { }

  ngOnInit() {
    this.isOpen = this.crmView;
  }

  public getDealTypeLabel(dealType: StructCapDealType): string {
    return StructCapCRMDealLabels[dealType];
  }

  public getSourceUsers() {
    return this.crmItem.sourceUsers.map(user => `${user.firstName} ${user.lastName}`).join(', ');
  }

  public getParticipants(): string {
    return this.crmItem.participants.map(value => value.user.fullName).join(', ');
  }

  public editCrmItem() {
    this.eventsHubService.openAddCrmModal({inputCrmItem: this.crmItem, editMode: true, crmItemType: CrmItemType.STRUCT_CAP, onSave: (data) => {
        this.saveCrmItemEvent.emit(data);
      }});
  }

  public openArchiveModal() {
    const modalRef = this.modalService.open(ArchiveModalComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.crmItem = this.crmItem;
    modalRef.result.then(data => {
      if (data) {
        this.archiveCrmItemEvent.emit(data);
      }
    });
  }

  public belowBreakpoint() {
    return document.documentElement.clientWidth < 768;
  }

  public openCrmHistory(crmItem: StructCapCRMItem) {
    window.open(`sonar/${STRUCT_CAP_URL_ROOT}/item/${crmItem.id}?audit=show`, '_blank');
  }

}
